import { Spinner } from 'design-system';

import {
  METADATA_COMPANY_NAME_FIELD,
  METADATA_FIRST_NAME_FIELD,
  METADATA_LAST_NAME_FIELD
} from '@/config/constants';
import { useUserConfig } from '@/features/_shared/user';
import AccountDetails from '@/features/profile/AccountDetails';
import AppVersion from '@/features/profile/AppVersion';
import MorningIntelMock from '@/features/profile/MorningIntelMock';
import PersonalDetails from '@/features/profile/PersonalDetails';
import Preferences from '@/features/profile/Preferences';
import Terms from '@/features/profile/Terms';
import TokenGenerationComponent from '@/features/profile/TokenGeneration';
import { retrieveFromUserMetadata } from '@/services/storage/userMetadata';
import useDocumentTitleRename from '@/shared/hooks/useDocumentTitleRename';
import { useAppSelector } from '@/store/hooks';

const Profile = () => {
  const { isLoading: isUserConfigLoading } = useUserConfig();
  const tripTokenState = useAppSelector(state => state.tripToken);

  useDocumentTitleRename('GX Go | Settings');

  return (
    <div className='flex w-full flex-col gap-6'>
      {isUserConfigLoading ? (
        <div className='flex min-h-40 items-center justify-center'>
          <Spinner className='size-6' />
        </div>
      ) : (
        <div className='flex max-w-[800px] mx-auto flex-col gap-6'>
          <PersonalDetails
            companyName={retrieveFromUserMetadata(
              tripTokenState.metadata ?? [],
              METADATA_COMPANY_NAME_FIELD
            )}
            email={tripTokenState.userEmail}
            firstName={retrieveFromUserMetadata(
              tripTokenState.metadata ?? [],
              METADATA_FIRST_NAME_FIELD
            )}
            lastName={retrieveFromUserMetadata(
              tripTokenState.metadata ?? [],
              METADATA_LAST_NAME_FIELD
            )}
          />
          <AccountDetails />
          <Preferences />
          <MorningIntelMock />
          <TokenGenerationComponent />
          <Terms />
          <AppVersion />
        </div>
      )}
    </div>
  );
};

export default Profile;
